/**
 * @link https://dirask.com/posts/JavaScript-check-if-any-text-on-web-page-is-selected-with-caret-j8VwmD
 */
export function isTextSelected() {
    var selection = window.getSelection();
    return selection && selection.type === 'Range';
}

/** 
 * This function takes a number of bytes and converts it to a human-readable format.
 */
export function bytesToHuman(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Bytes';
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}


export function copyToClipboard(what) {
    navigator.clipboard.writeText(what); 
    toastr.info('Copied to clipboard.'); 
}

export function initAllModules(rootElement = document, moduleNames = null, args = {}) {
    let kdModules = [];
    rootElement.querySelectorAll('*[kd-module]').forEach(elm => {
        if (elm.hasAttribute('kd-initted')) {
            return;
        }
        kdModules.push(initSingleModule(elm, moduleNames, args));
    });

    return kdModules;
}

export function initSingleModule(elm, moduleNames = null, args = {}) {
    
    moduleNames = moduleNames || elm.getAttribute('kd-module');

    if (typeof moduleNames === 'function') {
        moduleNames = [moduleNames];
    } else {
        moduleNames = moduleNames.split(',').map(moduleName => moduleName.trim());
    }

    moduleNames.forEach(moduleName => {
        let moduleFn;
        if (typeof moduleName === 'function') {
            moduleFn = moduleName;
        } else {
            moduleFn = window.modules[moduleName] || window[moduleName];
        }

        if (typeof moduleFn !== 'function') {
            throw new Error(`Module ${moduleName} not found.`);
        }
        let module = new moduleFn(elm, args);
        elm.kdModule = module;
    });
    
    elm.setAttribute('kd-initted', true);
    elm.dispatchEvent(new CustomEvent('kdinit'));
   
    return elm.kdModule;
}


export function onDelegatedClick(parent, selector, callback, useCapture) {
    return onDelegatedEvent('click', parent, selector, callback, useCapture);
}

export function onDelegatedEvent(eventName, parent, selector, callback, useCapture) {
    return parent.addEventListener(eventName, function(e) {

        let selectorTarget = e.target.closest(selector);

        if (!selectorTarget) {
            return;
        }

        e.selectorTarget = selectorTarget;

        callback(e);
        
    }, useCapture);
}

export function onClick(element, callback) {
    return element.addEventListener('click', function(e) {
        callback(e);
    });
}

export function isCursorAtEnd(inputElement) {
    return inputElement.selectionStart === inputElement.value.length;
}

export function isCursorAtStart(inputElement) {
    return inputElement.selectionStart === 0;
}

export function quoteattr(s, preserveCR) {
    preserveCR = preserveCR ? '&#13;' : '\n';
    return ('' + s) /* Forces the conversion to string. */
        .replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
        .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        /*
        You may add other replacements here for HTML only 
        (but it's not necessary).
        Or for XML, only if the named entities are defined in its DTD.
        */ 
        .replace(/\r\n/g, preserveCR) /* Must be before the next replacement. */
        .replace(/[\r\n]/g, preserveCR);
        ;
}

export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}


export function hasVerticalScrollBar(element) {
    return element.clientHeight < element.scrollHeight;
}

export function hasHorizontalScrollBar(element) {
   return element.clientWidth < element.scrollWidth;
} 

export function setSelectValue(select, value) {
    select.value = value;

    // Si no se establece es porque no hay un option, lo añadimos
    if (select.value !== value) {
        let optionElm = document.createElement('option');
        optionElm.value = value;
        optionElm.innerHTML = value;
        optionElm.selected = true;
        select.appendChild(optionElm);
    }
}

export function html(strings, ...values) {
    let str = '';
    strings.forEach((string, i) => {
        str += string + (values[i] || '');
    });
    return str;
}

/**
 * @since 2024-05-08 Added allow-scripts to sl-include
 * @since 2024-06-26 {{t}} is also replaced when URL encoded
 * @since 2024-06-26 options.style
 */
export function createDialogWithUrl(url, label, options = {}) {

    url = url.replace('{{t}}', Date.now());
    url = url.replace(encodeURIComponent('{{t}}'), Date.now());
    
    let dialog = document.createElement('sl-dialog');
    dialog.label = label;
    dialog.innerHTML = html`
        <sl-include src="${url}" allow-scripts>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
            <sl-skeleton effect="pulse" class="mb-1"></sl-skeleton>
        </sl-include>
    `;

    if (options.class) {
        dialog.classList.add(options.class);
    }

    if (options.style) {
        dialog.style = options.style;
    }

    document.body.appendChild(dialog);

    customElements.whenDefined('sl-dialog').then(() => {
        dialog.show();
    });

    dialog.addEventListener('sl-after-hide', event => {
        if (event.target === dialog) {
            dialog.remove();
        }
    });

    return dialog;
}

export function addParamsToUrl(url, params) {
    let urlObj = new URL(url, window.location.origin);

    for (let key in params) {
        urlObj.searchParams.delete(key);
        urlObj.searchParams.append(key, params[key]);
    }
    return urlObj.toString();
}

export function formDataToObject(formData) {

    let data = {};

    for (let key of formData.keys()) {
        data[key] = formData.get(key);
    }

    return data;
}

/**
 * @since 2024-05-06 Added X-Toastify
 */
export function processStandardBackendHeaders(response, scopeElement = null) {

    // Dispatch Event
        let eventName = response.headers.get('X-Dispatch-Event');
        if (eventName) {
            scopeElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true, }));
        }

    // Flash message
        let flashMessage = response.headers.get('X-Flash-Message');
        if (flashMessage) {
            if (typeof swalAlert === 'function') {
                swalAlert(flashMessage)
            } else {
                alert(flashMessage);
            }
        }

        let toastifyMessage = response.headers.get('X-Toastify');
        if (toastifyMessage && typeof Toastify !== 'undefined') {
            let background = response.headers.get('X-Toastify-Background') || 'green';
            Toastify({ 
                text: toastifyMessage, 
                duration: 3000,
                style: {
                    background: background,
                    color: 'white'
                }
            }).showToast();
        }

    // Redirect
        let redirect = response.headers.get('X-Location');

        if (redirect) {
            location.href = redirect;
        }

    return response;

}

// https://stackoverflow.com/a/47614491
export function setInnerHTMLWithScript(elm, html) {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll('script')).forEach( oldScriptEl => {
        const newScriptEl = document.createElement('script');
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
            newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
}

/**
 * Reemplaza el contenido de un elemento identificado por un id por el de el mismo dentro del HTML pasado como parámetro.
 * @param DOMElement target 
 * @param string sourceHtml 
 * @param object options 
 *      - callback: function
 *      - executeScripts: boolean
 * 
 * @since 2024-03-15 If the target element is not found in the source html, the function will console log the response
 * @since 2024-10-04 Added options
 */
export function replacePageContent(target, sourceHtml, options = {}) {

    let callback = options.callback || null;
    let executeScripts = options.executeScripts || false;

    let domId = target.getAttribute('id');

    let html;
    let tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = sourceHtml;
    let sourceElement = tmpDiv.querySelector('#' + domId);

    if (!sourceElement) {
        console.warn('Element with id ' + domId + ' not found in source html.');
        console.log(sourceHtml);
        return;
    }
    
    html = sourceElement.innerHTML;

    viewTransition(() => {
        target.scrollTop = 0;

        if (executeScripts) {
            setInnerHTMLWithScript(target, html);
        } else {
            target.innerHTML = html;
        }
        // target.style.display = '';
        initAllModules(target);

        callback && callback();
        
    });
}

/**
 * @since 2024-05-06 first param containers could be an array
 */
export function setLoading(containers, loading) {

    if (!Array.isArray(containers)) {
        containers = [containers];
    }

    containers.forEach(container => {
        let isStatic = window.getComputedStyle(container).position === 'static';

        if (loading) {
            if (isStatic) {
                container.style.position = 'relative';
            }
            container.classList.add('is-loading');
            
        } else {
            container.classList.remove('is-loading');
        }
    });
}

export function tryJsonParse(str) {
    try {
        return JSON.parse(str);
    } catch(e) {
        return null;
    }
}

export function viewTransition(callback) {
    if (document.startViewTransition) {
        document.startViewTransition(() => {
            callback();
        });
    } else {
        callback();
    }
}

export function setCss(elements, styles, value = null) {

    if (typeof styles === 'string' && value !== null) {
        styles = {
            [styles]: value
        };
    }

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    });
}